import React from 'react';
import PlayIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import Forward30Icon from '@material-ui/icons/Forward30';
import Replay10Icon from '@material-ui/icons/Replay10';
import IconButton from '@material-ui/core/IconButton';

const styles = {
  largeIcon: {
    width: '7.5vw',
    height: '7.5vw',
    minWidth: '40px',
    minHeight: '40px',
    color:'#fff'
  },
  large: {
    width: '12vw',
    height: '12vw',
    minWidth: '50px',
    minHeight: '50px',
    padding: '1.5vw',
    color:'#fff',

  }
};

class VideoPlayback extends React.Component {
  render = () => {
    if (!this.props.channelLoaded || !this.props.overlay) {
      return (<div />);
    }
    return (
      <div
        className="overlay"
        style={{position:'absolute',top: 0,left: 0,bottom: 0,right: 0, pointerEvents: 'none'}}
      >
        <PlaybackController overlay={this.props.overlay} onMouseEnter={this.props.onMouseEnter} onMouseLeave={this.props.onMouseLeave} />
      </div>
    );
  };
};
class PlaybackController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pause: true
    };
  }

  handleMouseEnterOrMouseMove = (e) => {
    this.props.onMouseEnter();
  };
  handleMouseLeave = (e) => {
    this.props.onMouseLeave();
  };
  createIconButton = (key, icon, action) => {
    return (
      <IconButton
        key={key}
        size="large"
        style={styles.large}
        sizeLarge={styles.large}
        onClick={e => {if (action !== undefined) action();}}
        onMouseEnter={this.handleMouseEnterOrMouseMove}
        onMouseMove={this.handleMouseEnterOrMouseMove}
        onMouseLeave={this.handleMouseLeave}
      >
        {icon}
      </IconButton>
    );
  };
  play = (video) => {
    video.play();
  };
  pause = (video) => {
    video.pause();
  };
  forward = (video) => {
    video.currentTime += 30;
    video.play();
  };
  rewind = (video) => {
    video.currentTime -= 10;
    video.play();
  };
  componentDidMount = () => {
    const video = document.getElementById('video');
    const self = this;
    video.onpause = () => {
      self.setState({pause: true});
    }
    video.onplay = () => {
      self.setState({pause: false});
    }
    this.setState({pause: video.paused});
  };
  render = () => {
    if (!this.props.overlay) {
      return (<div />);
    }
    const video = document.getElementById('video');
    // const invisibleStyle = {visibility: 'hidden'}; // Chrome 67から再生ボタンが表示されるようになったので隠す
    const iconButtons = [];
    iconButtons.push(this.createIconButton('rewind', <Replay10Icon style={styles.largeIcon}/>, () => this.rewind(video)));
    //var spaceStyle = {width: 120, height: 120, padding: 30, pointerEvents: 'none'};
    //iconButtons.push(<span style={spaceStyle} />);
    if (this.state.pause) {
      iconButtons.push(this.createIconButton('play', <PlayIcon style={styles.largeIcon}/>, () => this.play(video)));
    }
    else {
      iconButtons.push(this.createIconButton('pause', <PauseIcon style={styles.largeIcon}/>, () => this.pause(video)));
    }
    iconButtons.push(this.createIconButton('forward', <Forward30Icon style={styles.largeIcon}/>, () => this.forward(video)));
    const overlayStyle = {
      pointerEvents: 'visible',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: '-4.5vw',
      marginLeft: '-18vw'
    };
    return (
      <div
        key="playbackController"
        id="video-overlay"
        style={overlayStyle}
      >
        {iconButtons}
      </div>
    );
  };
};
export default VideoPlayback;



// WEBPACK FOOTER //
// ./src/components/VideoPlayback.js